<template>
	<div class="component-main">
		<div class="d-none d-md-block desktop-main" >
			<desktop-admin-slot-calendar/>
		</div>
<!--		<div class="d-md-none" >
			<mobile-admin-slot-calendar/>
		</div>-->
	</div>
</template>
<script>
import {RepositoryFactory} from '../api/RepositoryFactory'
import DesktopAdminSlotCalendar from './DesktopAdminSlotCalendar'
//import MobileAdminSlotCalendar from './MobileAdminSlotCalendar'
const SettingsRepoGet = RepositoryFactory.get('settings')
export default{
	name: 'AdminSlots',
	components: {DesktopAdminSlotCalendar},
	props: ['storeId', 'accessToken'],
	data(){
		return{}
	},
	created(){
		//window.localStorage.clear()
			//		this.$nextTick().then(() => {
			//	console.log(window.localStorage)	
		//this.getStoreSettings(this.$store.state.storeId)			
		//	});	
		console.log(this.$store.state)
	},
	methods: {
		async getStoreSettings(storeId)
		{
			const {data}  =	await SettingsRepoGet.getAllStoreSettings(storeId)	
		//	console.log(data)	
		//	console.log(this.$store.state)	
		//	console.log(this.$store.state.loggedIn)
			this.$store.commit("getStoreSettings", data);
		}
	}	
}

</script>
<style>
.component-main
{
	min-width: 320px;
}
</style>